(function (root, factory) {
  const data = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = data;
  }

  if (root) {
    root.KostkammBrushFinderData = data;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function parseSkus(value) {
    if (!value) return [];

    if (value === '4008.4047999999998') {
      return ['4008', '4048'];
    }

    return value
      .split(',')
      .map(function (sku) {
        return sku.trim();
      })
      .filter(Boolean);
  }

  function row(
    hairType,
    structure,
    length,
    curvedStandard,
    curvedVegan,
    narrowStandard,
    ovalStandard,
    ergonomicStandard,
    ergonomicLeft,
    ergonomicVegan,
    dropStandard,
    dropLeft,
    roundBackStandard,
    roundBackVegan
  ) {
    return {
      hairType: hairType,
      structure: structure,
      length: length,
      shapes: {
        curved: {
          standard: parseSkus(curvedStandard),
          vegan: parseSkus(curvedVegan),
        },
        narrow: {
          standard: parseSkus(narrowStandard),
        },
        oval: {
          standard: parseSkus(ovalStandard),
        },
        ergonomic: {
          standard: parseSkus(ergonomicStandard),
          left: parseSkus(ergonomicLeft),
          vegan: parseSkus(ergonomicVegan),
        },
        drop: {
          standard: parseSkus(dropStandard),
          left: parseSkus(dropLeft),
        },
        roundBack: {
          standard: parseSkus(roundBackStandard),
          vegan: parseSkus(roundBackVegan),
        },
      },
    };
  }

  const rows = [
    row('none', null, null, null, null, null, '4020, 4025', '4030, 4035, 4070, 4090', null, '4031', '4050, 4055, 4080', '4050L', null, null),
    row('thin', 'straight', 'short', null, null, '4010', '4020, 4025', '4030, 4035, 4070, 4090', null, '4031', '4050, 4055, 4080', '4050L', null, null),
    row('thin', 'straight', 'medium', null, null, '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', null, null),
    row('thin', 'straight', 'long', null, '4001, 4041', '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', null, null),
    row('thin', 'wavy', 'short', null, null, '4010', '4020, 4025', '4030, 4035, 4070, 4090', null, '4031', '4050, 4055, 4080', '4050L', null, null),
    row('thin', 'wavy', 'medium', null, null, '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', null, null),
    row('thin', 'wavy', 'long', null, '4001, 4041', '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', null, null),
    row('thin', 'curly', 'short', null, null, '4010', '4020, 4025', '4030, 4035, 4070, 4090', null, '4031', '4050, 4055, 4080', '4050L', null, null),
    row('thin', 'curly', 'medium', null, null, '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', null, null),
    row('thin', 'curly', 'long', null, '4001, 4041', '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', null, null),
    row('fine', 'straight', 'short', null, null, '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', null, null),
    row('fine', 'straight', 'medium', null, null, '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4058, 4080', '4050L', '435, 437', '4360'),
    row('fine', 'straight', 'long', null, '4001, 4041', '4010', '4020', '4030, 4070, 4090', null, '4031', '4058', '4050L', '435, 437', '4360'),
    row('fine', 'wavy', 'short', null, null, '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4080', '4050L', '435, 437', '4360'),
    row('fine', 'wavy', 'medium', null, null, '4010', '4020', '4030, 4070, 4090', null, '4031', '4050, 4058, 4080', '4050L', '435, 437', '4360'),
    row('fine', 'wavy', 'long', '4008.4047999999998', '4001, 4041', '4010, 4018', '4020, 4028', '4030, 4038, 4070, 4078, 4090, 4098', '4038L', '4031', '4058', null, '436, 438', '4360'),
    row('fine', 'curly', 'short', null, null, '4010', '4020', '4030, 4070, 4090, ', null, '4031', '4058', null, '435, 437', '4360'),
    row('fine', 'curly', 'medium', '4008.4047999999998', '4001, 4041', '4010, 4018', '4020, 4028', '4030, 4038, 4070, 4078, 4090, 4098', '4038L', '4031', null, null, '435, 437', '4360'),
    row('fine', 'curly', 'long', '4008.4047999999998', '4001, 4041', '4018', '4028', '4038, 4078, 4098', '4038L', '4031', null, null, '436, 438', '4360'),
    row('strong', 'straight', 'short', '4008.4047999999998', '4001, 4041', '4010, 4018', '4020, 4028', '4030, 4038, 4070, 4078, 4090, 4098', '4038L', '4031', '4058', null, '435, 437', '4360'),
    row('strong', 'straight', 'medium', '4008.4047999999998', '4001, 4041', '4018', '4028', '4038, 4039, 4078, 4079, 4098', '4038L', '4031', null, null, '435, 437', '4360'),
    row('strong', 'straight', 'long', '4008, 4009, 4048, 4049', null, '4018, 4019', '4028, 4029', '4038, 4039, 4078, 4079, 4098', '4038L', null, null, null, '436, 438', '4360'),
    row('strong', 'wavy', 'short', '4008.4047999999998', '4001, 4041', '4018', '4028', '4038, 4078, 4098', '4038L', '4031', null, null, '435, 437', '4360'),
    row('strong', 'wavy', 'medium', '4008.4047999999998', '4001, 4041', '4018', '4028', '4038, 4039, 4078, 4079, 4098', '4038L', null, null, null, '435, 437', '4360'),
    row('strong', 'wavy', 'long', '4008, 4009, 4048, 4049', null, '4018, 4019', '4028, 4029', '4038, 4039, 4078, 4079, 4098', '4038L', null, null, null, '436, 438', null),
    row('strong', 'curly', 'short', '4008.4047999999998', '4001, 4041', '4018', '4028', '4038, 4078, 4098', '4038L', '4031', null, null, '435, 437', '4360'),
    row('strong', 'curly', 'medium', '4008.4047999999998', null, '4018', '4028', '4038, 4078, 4098', '4038L', null, null, null, '436, 438', null),
    row('strong', 'curly', 'long', '4008, 4009, 4048, 4049', null, '4018, 4019', null, '4039, 4079', null, null, null, null, null, null),
    row('thick', 'straight', 'short', '4008.4047999999998', '4001, 4041', '4018', '4028', '4038, 4078, 4098', '4038L', null, null, null, '436, 438', '4360'),
    row('thick', 'straight', 'medium', '4008, 4009, 4048, 4049', null, '4018, 4019', '4028, 4029', '4038, 4039, 4078, 4079, 4098', '4038L', null, null, null, '436, 438', null),
    row('thick', 'straight', 'long', '4008, 4009, 4048, 4049', null, '4018, 4019', '4028, 4029', '4038, 4039, 4078, 4079, 4098', '4038L', null, null, null, '436, 438', null),
    row('thick', 'wavy', 'short', '4008.4047999999998', '4001, 4041', '4018', '4028', '4038, 4078, 4098', '4038L', null, null, null, '436, 438', '4360'),
    row('thick', 'wavy', 'medium', '4008, 4009, 4048, 4049', null, '4018, 4019', '4029', '4039, 4079', null, null, null, null, '436, 438', '4360'),
    row('thick', 'wavy', 'long', '4008, 4009, 4048, 4049', null, '4018, 4019', '4029', '4039, 4079', null, null, null, null, '436, 438', '4360'),
    row('thick', 'curly', 'short', '4008, 4009, 4048, 4049', null, '4018, 4019', '4028, 4029', '4038, 4039, 4078, 4079, 4098', '4038L', null, null, null, '436, 438', null),
    row('thick', 'curly', 'medium', '4008, 4009, 4048, 4049', null, '4018, 4019', '4029', '4039, 4079', null, null, null, null, null, '4360'),
    row('thick', 'curly', 'long', '4008, 4009, 4048, 4049', null, '4018, 4019', '4029', '4039, 4079', null, null, null, null, null, null),
  ];

  function deepFreeze(value) {
    Object.getOwnPropertyNames(value).forEach(function (name) {
      const child = value[name];
      if (child && typeof child === 'object' && !Object.isFrozen(child)) {
        deepFreeze(child);
      }
    });
    return Object.freeze(value);
  }

  return deepFreeze({
    schemaVersion: 1,
    rows: rows,
  });
});
